import { array } from 'prop-types'
import { useMemo } from 'react'
import styled from 'styled-components'
import { MainCategory } from './MainCategory'

export const MainCategories = ({ categories, auctionCategories }) => {
  const mainCategories = useMemo(() => {
    if (!categories?.length || !auctionCategories?.length) return []

    return auctionCategories
      .filter(({ featured }) => featured)
      .sort((a, b) => (a.index = b.index))
      .map(({ id }) => categories.find(({ value }) => value === id))
      .filter(cat => cat)
  }, [categories, auctionCategories])

  return (
    <Wrap>
      {mainCategories.map(({ value, label }) => (
        <MainCategory key={value} id={value} label={label} />
      ))}
    </Wrap>
  )
}

MainCategories.propTypes = {
  categories: array,
  auctionCategories: array,
}

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
`
